module.exports = __webpack_public_path__ + "img/rg-target-vessel-danger-default.48e19fc2.svg";